import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("Confirming payment…");
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);
  const { setAuth, refresh } = useAuth();
  const nav = useNavigate();
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setError("Missing session id.");
      return;
    }
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") {
          if (data.token && data.user) {
            setAuth(data.token, data.user);
          } else {
            await refresh();
          }
          if (!cancelled) {
            setStatus("Payment confirmed.");
            setDone(true);
            setTimeout(() => nav("/dashboard"), 1100);
          }
          return;
        }
        if (data.status === "expired") {
          setError("Payment session expired. Please try again.");
          return;
        }
        attempts.current += 1;
        if (attempts.current >= 10) {
          setError("Could not confirm payment after several attempts. Please refresh or check your email.");
          return;
        }
        setTimeout(poll, 2000);
      } catch (e) {
        if (attempts.current < 8) {
          attempts.current += 1;
          setTimeout(poll, 2000);
        } else {
          setError("Could not confirm payment. Please contact support.");
        }
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, setAuth, refresh, nav]);

  return (
    <div style={{ maxWidth: 480, margin: "100px auto", padding: "0 24px", textAlign: "center" }}>
      <div className="bg-card-gold" style={{ padding: 44 }}>
        <div style={{ fontSize: 44, color: "var(--gold)", marginBottom: 14 }}>{done ? "✓" : "✦"}</div>
        <h1 className="serif" style={{ fontSize: 32, color: "#fff", margin: "0 0 12px", fontWeight: 400 }}>
          {done ? "Welcome to Obituary Relief" : "One moment"}
        </h1>
        {error ? (
          <p style={{ color: "#ff8a8a" }}>{error}</p>
        ) : (
          <p className="muted">{status}</p>
        )}
        {error && (
          <button onClick={() => nav("/signup")} className="btn-gold" style={{ marginTop: 18 }}>Back to signup</button>
        )}
      </div>
    </div>
  );
}
